export function getParams () {
    let index = location.href.lastIndexOf('/')
    return window.location.href.slice(index + 1)
}

export function getTime () {
    // return Math.ceil(Date.now() / 1000)
    let queryObj = getQueryObject(window.location.href);
    return queryObj && queryObj.ts  ? queryObj.ts : '';
}

function getQueryObject(url) {
    let search = url.substring(url.lastIndexOf("?") + 1);
    let obj = {};
    let reg = /([^?&=]+)=([^?&=]*)/g;
    search.replace(reg, function (rs, key, value) {
        let name = decodeURIComponent(key);
        let val = decodeURIComponent(value);
        val = String(val);
        obj[name] = val;
        return rs;
    });
    return obj;
}